document.addEventListener('DOMContentLoaded', function () {
  var quickview = document.querySelectorAll('.quickview');

  var mainImage = document.querySelector('#productModal .modal-body .product-images .main-image img');
  //var mainHref = document.querySelector('#productModal .modal-body .product-images .main-image a');
  //var otherImage = document.querySelector('#productModal .modal-body .product-images .other-image ul');
  // var rating = document.querySelector('#productModal .modal-body .product-desc .rating');
  var modalTitle = document.querySelector('#productModal .modal-body .product-info h2');
  var price = document.querySelector('#productModal .modal-body .product-info .price-box .price');
  var modalDesc = document.querySelector('#productModal .modal-body .product-info .quick-desc');
  var mainDescHref = document.querySelector('#productModal .modal-body .product-info .see-all');
  var share = document.querySelector('#productModal .modal-body .product-info .social-sharing');
  var btnAdd = document.querySelector('#productModal .modal-body .product-info .quick-add-to-cart .single_add_to_cart_button');

  var fieldAdd = document.querySelector('#productModal .modal-body .product-info .quick-add-to-cart #id');
  // var btnCompare = document.querySelector('#productModal .modal-body .product-info .button-group .btn-compare');
  // var btnWishlist = document.querySelector('#productModal .modal-body .product-info .button-group .btn-wishlist');
  document.addEventListener('click', function(event) {
    // Check if the clicked element is a quickview button
    if (event.target.matches('.quickview')) {
      // otherImage.innerHTML = ' ';
      // rating.innerHTML = ' ';
      price.innerHTML = '';
  
      var product_info = event.target.dataset.productinfo;
      product_info = JSON.parse(product_info);
      mainImage.setAttribute('src', product_info['images'][0]);
      //mainHref.setAttribute('href', '/products/' + product_info['handle']);
      mainDescHref.setAttribute('href', '/products/' + product_info['handle']);
  
      // var arr_image = product_info['images'];
      // for (var i = 0; i < arr_image.length && i < 3; i++) {
      //   otherImage.innerHTML += `<li><img style="width:78px;cursor:pointer" class="img-thumbnail other-image" width="78" height="auto" loading="lazy" src="${arr_image[i]}"></li>`;
      // }

      // document.querySelectorAll('.other-image').forEach(function(element) {
      //   element.addEventListener('click', function() {
      //     mainImage.setAttribute('src', this.getAttribute('src'));
      //   });
      // });

      modalTitle.innerHTML = product_info['title'];
      var desc = product_info['description'];
      var res = desc.trim();
      modalDesc.innerHTML = res.substring(0, 150);
      // rating.innerHTML = `<span class="shopify-product-reviews-badge" data-id="${product_info['id']}"></span>`;

      if(product_info['price']){ 		
        if(product_info['compare_at_price']){ 
          if (typeof Currency !== 'undefined') {
            price.insertAdjacentHTML('beforeend', '<span class="new-price"><span class="money">'+ Shopify.formatMoney(product_info["price"], Currency.moneyFormats[shopCurrency].money_format) +'</span></span><span class="old-price"><span class="money">'+ Shopify.formatMoney(product_info["compare_at_price"], Currency.moneyFormats[shopCurrency].money_format) +'</span></span>');
            // price.appendChild('<span class="new-price"><span class="money">'+ Shopify.formatMoney(product_info["price"], Currency.moneyFormats[shopCurrency].money_format) +'</span></span><span class="old-price"><span class="money">'+ Shopify.formatMoney(product_info["compare_at_price"], Currency.moneyFormats[shopCurrency].money_format) +'</span></span>');
          } else {
            price.insertAdjacentHTML('beforeend', '<span class="new-price"><span class="money">' + Shopify.formatMoney(product_info["price"], moneyFormat) +'</span></span><span class="old-price"><span class="money">'+ Shopify.formatMoney(product_info["compare_at_price"], moneyFormat) +'</span></span>');
            // price.appendChild('<span class="new-price"><span class="money">' + Shopify.formatMoney(product_info["price"], moneyFormat) +'</span></span><span class="old-price"><span class="money">'+ Shopify.formatMoney(product_info["compare_at_price"], moneyFormat) +'</span></span>');
          }
        }
        else{ 			
          if (typeof Currency !== 'undefined') {
            price.insertAdjacentHTML('beforeend', '<span class="new-price"><span class="money">'+ Shopify.formatMoney(product_info["price"], Currency.moneyFormats[shopCurrency].money_format) +'</span></span>');
            // price.appendChild('<span class="new-price"><span class="money">'+ Shopify.formatMoney(product_info["price"], Currency.moneyFormats[shopCurrency].money_format) +'</span></span>');
          } else {
            price.insertAdjacentHTML('beforeend', '<span class="new-price"><span class="money">'+ Shopify.formatMoney(product_info["price"], moneyFormat) + '</span></span>');
            // price.appendChild('<span class="new-price"><span class="money">'+ Shopify.formatMoney(product_info["price"], moneyFormat) + '</span></span>');
          }
        }
      }

      if(mt.show_multiple_currencies){
        if (Currency.cookie.read() != null) {
          Currency.convertAll(shopCurrency, Currency.cookie.read());
        }
      }
  
      fieldAdd.value = product_info['variants'][0]['id'];

      if(product_info['available'] != false ){
        btnAdd.setAttribute('href', '/products/' + product_info['handle']);
      } else {
        btnAdd.classList.add('disabled','btn');
        btnAdd.innerHTML = mt.product.sold_out;
        btnAdd.setAttribute('href', 'javascript:void(0)');
      }
      
      // btnCompare.setAttribute('onclick', 'compare.add(' + product_info['product_id'] + ')');
      // btnWishlist.setAttribute('onclick', 'wishlish.add(' + product_info['product_id'] + ')');

    }

  });
});